import { ApolloError } from '@apollo/client';
/**
 * The error a query or mutation result carries when the server answered with GraphQL errors.
 *
 * For tests. `FamlyOperationError` names the error but cannot build one, because Apollo Client 4
 * deletes the class instead of moving it. The README says what this returns once it does.
 */
export const createGraphQLOperationError = (graphQLErrors) => new ApolloError({ graphQLErrors });
